module.exports = __webpack_public_path__ + "static/media/psd.5fd3288e.svg";